import {IAddInsoleResult, IInsolesListEntry} from "admins-dashboard/http-clients/index";

export const createdInsoleTypePipe = (insole: IAddInsoleResult | IInsolesListEntry): string => {
    if (insole.isLeft) {
        return 'left';
    }
    return 'right';
};
